import React from "react";
import {
  Grid,
  Divider,
  Typography,
  Box,
  Link,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Facebook, Twitter, Instagram } from "@mui/icons-material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { Link as RouterLink } from "react-router-dom";
import XIcon from "@mui/icons-material/X";
export default function Footer() {
  const theme = useTheme();
  const isLarge = useMediaQuery("(min-width: 1920px)");
  const isUltraWide = useMediaQuery("(max-width: 2560px)");
  const is2XLarge = useMediaQuery("(min-width: 3840px)");
  const isMobile = useMediaQuery("(max-width: 495px)");
  const isTablet = useMediaQuery("(max-width: 768px)");

  // Services and Company links with React Router paths
  const servicesData = [
    { title: "Cloud Solutions", to: "/service/cloud-solutions" },
    { title: "Applied AI", to: "/service/applied-ai" },
    { title: "Data Solutions", to: "/service/data-solutions" },
  ];
  const Company = [
    { title: "About DevAngles", to: "/about" },
    { title: "Let's Talk", to: "/contact" },
    // { title: "Join Us", to: "/joinus" },
    { title: "Alliance", to: "/alliance" },
    // { title: "Privacy Policy", to: "/privacy-policy" },
    // { title: "Terms of Use", to: "/terms-of-use" },
  ];

  return (
    <Box
      sx={{
        backgroundColor: "#00002D",
        width: "100%",
        display: "flex",
        justifyContent: {
          xs: "flex-start",
          sm: "flex-start",
          md: "center",
        },
        alignItems: {
          xs: "flex-start",
          sm: "flex-start",
          md: "center",
        },
        height: {
          xs: "650px", // or a specific value if needed
          sm: "800px",
          md: "100%",
        },
      }}
    >
      <Box
        sx={{
          maxWidth: "100%",
          margin: isMobile
            ? "50px 0px"
            : is2XLarge
            ? "50px 850px"
            : isTablet
            ? "50px 0"
            : "50px 70px",
          paddingX: isTablet ? "4%" : "8%",
        }}
      >
        <Grid container spacing={2.5} justifyContent="space-between">
          {/* Logo & Description */}
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Box
              component="img"
              src="/DarkBackground.webp"
              alt="DevAngles logo – Delivering simple, innovative, and excellent digital IT solutions"
              loading="eager"
              sx={{
                width: is2XLarge || isLarge ? 350 : 250,
                height: 22, // Explicit height added (adjust as per actual image aspect ratio)
                marginBottom: 2,
              }}
            />
            <Typography
              sx={{
                color: "#FFFFFFDB",
                fontSize: { xs: "14px", md: "16px" }, // Responsive sizing
                fontWeight: 300,
                lineHeight: 1.5, // Explicit line height
                fontDisplay: "swap", // Critical for font loading
                willChange: "transform", // Hint for browser optimization
                "&::before": {
                  content: '""',
                  display: "block",
                  height: 0,
                  visibility: "hidden",
                  fontFamily: '"Lexend", sans-serif', // Force font preload
                },
              }}
            >
              We help organizations unlock new business opportunities and
              enhance customer journeys with cloud, data, and AI driven
              insights.
            </Typography>
          </Grid>

          {/* Services Links */}
          <Grid item xs={6} sm={6} md={2} lg={2}>
            <QuickLinks
              title="What We Do"
              links={servicesData}
              sx={{fontWeight: 300,}}
              fontSize={
                is2XLarge
                  ? "33px"
                  : isLarge
                  ? "18px"
                  : isMobile
                  ? "16px"
                  : isTablet
                  ? "18px"
                  : "20px"
              }
            />
          </Grid>
          <Grid item xs={6} sm={6} md={2} lg={2}>
            <QuickLinks
              title="Who We Are"
              links={Company}
              sx={{fontWeight: 300,}}
              fontSize={
                is2XLarge
                  ? "33px"
                  : isLarge
                  ? "18px"
                  : isMobile
                  ? "16px"
                  : isTablet
                  ? "18px"
                  : "20px"
              }
            />
          </Grid>
          {/* Contact Us section */}
          <Grid item xs={12} sm={12} md={2} lg={4}>
            <ContactInfo
              fontSize={
                is2XLarge
                  ? "33px"
                  : isLarge
                  ? "18px"
                  : isMobile
                  ? "16px"
                  : isTablet
                  ? "18px"
                  : "20px"
              }
            />
          </Grid>
        </Grid>

        {/* Footer Bottom */}
        <Divider sx={{ my: 4, borderColor: "rgba(255, 255, 255, 0.86)" }} />
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "start",
            alignItems: "start",
            flexWrap: "wrap", // allows wrap on smaller screens
            gap: 1.5, // spacing between items
            textAlign: "center",
            py: 2, // optional padding
          }}
        >
          <Typography
            sx={{
              color: "#FFFFFFD9",
              fontWeight: 300,
              fontSize: is2XLarge
                ? "20px"
                : isLarge
                ? "16px"
                : isMobile
                ? "12px"
                : isTablet
                ? "12px"
                : "14px",
            }}
          >
            © {new Date().getFullYear()} DevAngles. All rights reserved.
          </Typography>
          <Box>
          <Link to="/privacy-policy" style={{ textDecoration: 'none' }}>
    <Typography
      sx={{
        color: "#FFFFFFD9",
        fontWeight: 300,
        fontSize: is2XLarge
          ? "20px"
          : isLarge
          ? "16px"
          : isMobile
          ? "12px"
          : isTablet
          ? "12px"
          : "14px",
        cursor: "pointer",
      }}
    >
      
      <Link
            href="/privacy-policy"
            sx={{ color: "#FFFFFFD9", textDecoration: "none" }}
          >
             |&nbsp;&nbsp;Privacy Policy
          </Link>
    </Typography>
  </Link>
  </Box>
  <Box>
 
    <Typography
      sx={{
        color: "#FFFFFFD9",
        fontWeight: 300,
        fontSize: is2XLarge
          ? "20px"
          : isLarge
          ? "16px"
          : isMobile
          ? "12px"
          : isTablet
          ? "12px"
          : "14px",
        cursor: "pointer",
      }}
    >
      <Link
            href="/terms-of-use"
            sx={{ color: "#FFFFFFD9", textDecoration: "none" }}
          >
             Terms of Use
          </Link>
    
    </Typography>
 
  </Box>
        </Box>
      </Box>
    </Box>
  );
}
function QuickLinks({ title, links, fontSize }) {
  const isLarge = useMediaQuery("(min-width: 1920px)");
  const isUltraWide = useMediaQuery("(max-width: 2560px)");
  const is2XLarge = useMediaQuery("(min-width: 3840px)");
  const isMobile = useMediaQuery("(max-width: 495px)");
  const isTablet = useMediaQuery("(max-width: 768px)");
  return (
    <Box sx={{ color: "#FFFFFFD9" }}>
      <Typography variant="h6" sx={{ fontWeight: 500, marginBottom: 1.5 }}>
        {title}
      </Typography>
      <Box>
        {links.map((link, index) => (
          <Link
            key={index}
            component={RouterLink} // Enables routing
            to={link.to} // Navigates to the correct service page
            sx={{
              display: "block",
              color: "#FFFFFFD9",
              textDecoration: "none",
              marginBottom: 2.7,
              fontSize: is2XLarge
                ? "20px"
                : isLarge
                ? "14px"
                : isMobile
                ? "12px"
                : isTablet
                ? "12px"
                : "14px",
              "&:hover, &:focus": {
                textDecoration: "underline",
              },
            }}
          >
            {link.title}
          </Link>
        ))}
      </Box>
    </Box>
  );
}
function ContactInfo({ fontSize }) {
  const isLarge = useMediaQuery("(min-width: 1920px)");
  const isUltraWide = useMediaQuery("(max-width: 2560px)");
  const is2XLarge = useMediaQuery("(min-width: 3840px)");
  const isMobile = useMediaQuery("(max-width: 495px)");
  const isTablet = useMediaQuery("(max-width: 768px)");
  return (
    <Box sx={{ color: "#FFFFFFD9" }}>
      <Typography variant="h6" sx={{ fontWeight: 500, marginBottom: 1.5 }}>
        Contact Us
      </Typography>
      <Box>
        <Typography
          variant="body1"
          sx={{
            fontWeight: 300,
            marginBottom: 1.5,
            fontSize: is2XLarge
              ? "20px"
              : isLarge
              ? "14px"
              : isMobile
              ? "12px"
              : isTablet
              ? "12px"
              : "14px",
          }}
        >
          <strong>Phone:</strong>{" "}
          <Link
            href="tel:+6545667543"
            sx={{ color: "#FFFFFFD9", textDecoration: "none" }}
          >
            +91-20-4863 6888
          </Link>
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontWeight: 300,
            fontSize: is2XLarge
              ? "20px"
              : isLarge
              ? "14px"
              : isMobile
              ? "12px"
              : isTablet
              ? "12px"
              : "14px",
          }}
        >
          <strong>Email:</strong>{" "}
          <Link
            href="mailto:contact@devangles.com"
            sx={{ color: "#FFFFFFD9", textDecoration: "none" }}
          >
            contact@devangles.com
          </Link>
        </Typography>

        {/* Social Links */}
        <Box sx={{ display: "flex", gap: 2, marginTop: 2 }}>
          <Link
            href="https://in.linkedin.com/company/dev-angles"
            aria-label="LinkedIn"
          >
            <LinkedInIcon sx={{ fontSize, color: "#FFFFFFD9" }} />
          </Link>
          <Link href="https://x.com/DevAnglesTeam" aria-label="Twitter">
            <XIcon sx={{ fontSize, color: "#FFFFFFD9" }} />
          </Link>
          {/* <Link href="#" aria-label="Instagram">
            <Instagram sx={{ fontSize,color: "#FFFFFFD9" }} />
          </Link> */}
        </Box>
      </Box>
    </Box>
  );
}
